import { BottomSheetModalMethods } from '@gorhom/bottom-sheet/src/types';
import BelievePaymentBottomSheet, {
  BelievePaymentBottomSheetProps,
} from 'features/home/HomeScreen/components/BelievePaymentBottomSheet/BelievePaymentBottomSheet';
import BrazeBottomSheetContent, {
  BrazeBottomSheetProps,
} from 'features/home/HomeScreen/components/BrazeBottomSheet/BrazeBottomSheet';
import EncourageDdAfterVaSuccessBottomSheet, {
  EncourageDdAfterVaSuccessBottomSheetProps,
} from 'features/home/HomeScreen/components/EncourageDdAfterVaSuccessBottomSheet/EncourageDdAfterVaSuccessBottomSheet';
import React, { RefObject } from 'react';

export interface HomeScreenBottomSheetProps {
  data:
    | BelievePaymentBottomSheetProps
    | BrazeBottomSheetProps
    | EncourageDdAfterVaSuccessBottomSheetProps
    | null;
  bottomSheetRef: RefObject<BottomSheetModalMethods | null> | null;
}

const isBelievePaymentProps = (
  data:
    | BelievePaymentBottomSheetProps
    | BrazeBottomSheetProps
    | EncourageDdAfterVaSuccessBottomSheetProps
    | null,
): data is BelievePaymentBottomSheetProps => {
  return (data as BelievePaymentBottomSheetProps).data !== undefined;
};

const isEncourageDdAfterVaSuccessProps = (
  data:
    | BelievePaymentBottomSheetProps
    | BrazeBottomSheetProps
    | EncourageDdAfterVaSuccessBottomSheetProps
    | null,
): data is EncourageDdAfterVaSuccessBottomSheetProps => {
  return (
    (data as EncourageDdAfterVaSuccessBottomSheetProps).onDismiss !== undefined
  );
};

const HomeScreenBottomSheet = ({
  data,
  bottomSheetRef,
}: HomeScreenBottomSheetProps) => {
  if (!data) {
    return null;
  }

  if (isEncourageDdAfterVaSuccessProps(data)) {
    return (
      <EncourageDdAfterVaSuccessBottomSheet
        {...data}
        bottomSheetRef={bottomSheetRef ?? undefined}
      />
    );
  }

  if (isBelievePaymentProps(data)) {
    return (
      <BelievePaymentBottomSheet
        bottomSheetRef={bottomSheetRef}
        id={data.id}
        data={data.data}
      />
    );
  }
  return (
    <BrazeBottomSheetContent
      {...(data as BrazeBottomSheetProps)}
      bottomSheetRef={bottomSheetRef ?? undefined}
    />
  );
};

export default HomeScreenBottomSheet;
